import helperServices from '../../services/helperServices'

export default class {
  constructor (model) {
    this.heated = model.heated
    this.indoor = model.indoor
    this.paddling = model.paddling
    this.waterSlides = model.waterSlides
    this.supervised = model.supervised
    this.shortAllowed = model.shortAllowed
    this.nbPools = model.nbPools
    this.openingDate = model.openingDate
    this.inputOpeningDate = helperServices.getDateForInput(this.openingDate)
    this.closingDate = model.closingDate
    this.inputClosingDate = helperServices.getDateForInput(this.closingDate)
    this.openingTime = model.openingTime
    this.inputOpeningTime = helperServices.getTimeForInput(this.openingTime)
    this.closingTime = model.closingTime
    this.inputClosingTime = helperServices.getTimeForInput(this.closingTime)
  }
}
